import React from 'react';
import { Search, BarChart2, Globe, Target, Zap, Shield } from 'lucide-react';
import Container from './Container';
import Button from './Button';

const features = [
  {
    icon: Search,
    title: 'AI-Powered Keyword Research',
    description: 'Discover high-converting keywords specific to the roofing industry'
  },
  {
    icon: BarChart2,
    title: 'Competitor Analysis',
    description: 'Track and outperform local roofing competitors'
  },
  {
    icon: Globe,
    title: 'Local SEO Optimization',
    description: 'Dominate local search results in your service areas'
  },
  {
    icon: Target,
    title: 'GBP Optimization',
    description: 'Maximize your Google Business Profile visibility'
  },
  {
    icon: Zap,
    title: 'Real-time Performance',
    description: 'Track rankings and performance in real-time'
  },
  {
    icon: Shield,
    title: 'White-hat Techniques',
    description: 'Safe, Google-compliant optimization strategies'
  }
];

const ProductShowcase = () => {
  return (
    <section id="products" className="py-20 bg-white">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Meet OTTO by Search Atlas
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            The all-in-one SEO solution designed specifically for roofing companies
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="p-6 rounded-2xl border border-gray-200 hover:border-blue-500 transition-colors"
            >
              <div className="bg-blue-50 w-12 h-12 rounded-xl flex items-center justify-center mb-4">
                <feature.icon className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button className="text-lg px-8 py-4" withArrow>
            Explore All Features
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default ProductShowcase;